import { AppConfiguration } from '#app/types.js';
import { type OperationType, type PreloadedQuery } from '@contra/relay';
import { createContext } from 'react';
import { type PageContextClient } from 'vike/types';

/**
 * Note that this pageContext is accurate only for client-side code.
 * Server context is available from `import {type ServerPageContext} from '#app/types'`.
 */
export type PageContext<Result extends OperationType = never> = {
  exports: {
    authenticationRequired?: boolean;
    pageConcreteRequest: Result extends OperationType
      ? PreloadedQuery<Result>
      : never;
  };
  origin: string;
  Page: (pageProps: PageProps) => React.ReactElement;
  pageId: string;
  publicAppConfiguration: AppConfiguration;
  routeParams: Record<string, string>;
  urlOriginal: string;
  urlParsed: PageContextClient['urlParsed'];
  urlPathname: string;
};

type PageProps = {
  preloaded?: PreloadedQuery<OperationType, {}>;
};

export const PageContextContext = createContext<null | PageContext>(null);
